/* 3D Mapping Tools — behavior for the mdt- sections. No dependencies. */
(function () {
  'use strict';

  // YouTube: show a thumbnail until clicked, then load the player. Keeps pages fast.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mdt-video]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-mdt-video');
    var title = btn.getAttribute('data-title') || 'YouTube video';
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    frame.title = title;
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    var box = document.createElement('div');
    box.className = 'mdt-video';
    box.appendChild(frame);
    btn.replaceWith(box);
  });

  // Video strip: a thumbnail opens the video in a pop-out player. Closing it removes the player, so the sound stops.
  var pop;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mdt-video-pop]');
    if (!btn) return;
    e.preventDefault();
    if (!pop) {
      pop = document.createElement('dialog');
      pop.className = 'mdt mdt-vpop';
      pop.setAttribute('aria-label', 'Video player');
      pop.innerHTML = '<div class="mdt-vpop__bar"><span class="mdt-vpop__title"></span>'
        + '<a class="mdt-vpop__yt" target="_blank" rel="noopener">Watch on YouTube ↗</a>'
        + '<button type="button" class="mdt-vpop__close" aria-label="Close video">×</button></div>'
        + '<div class="mdt-video mdt-vpop__frame"></div>';
      document.body.appendChild(pop);
      pop.addEventListener('click', function (ev) {
        if (ev.target === pop || (ev.target.closest && ev.target.closest('.mdt-vpop__close'))) pop.close();
      });
      pop.addEventListener('close', function () { pop.querySelector('.mdt-vpop__frame').innerHTML = ''; });
    }
    var id = btn.getAttribute('data-mdt-video-pop');
    var title = btn.getAttribute('data-title') || 'YouTube video';
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    frame.title = title;
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    pop.querySelector('.mdt-vpop__title').textContent = title;
    pop.querySelector('.mdt-vpop__yt').href = 'https://www.youtube.com/watch?v=' + encodeURIComponent(id);
    var box = pop.querySelector('.mdt-vpop__frame');
    box.innerHTML = '';
    box.appendChild(frame);
    pop.showModal();
  });

  // Product gallery: thumbnails swap the main image; the video thumbnail opens the video.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-mdt-thumb]');
    if (!t) return;
    var gallery = t.closest('[data-mdt-gallery]');
    if (!gallery) return;
    var stage = gallery.querySelector('[data-mdt-stage]');
    if (!stage) return;
    stage.src = t.getAttribute('data-mdt-thumb');
    stage.srcset = t.getAttribute('data-srcset') || '';
    stage.alt = t.getAttribute('data-alt') || '';
    stage.classList.toggle('is-cover', t.hasAttribute('data-cover'));
    gallery.querySelectorAll('[data-mdt-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
  });

  // Add to cart: the product plus any ticked add-ons and add-on quantities, in one request, then go to the cart.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-mdt-buy]');
    if (!form) return;
    e.preventDefault();
    var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10) || 1;
    var items = [{ id: parseInt(form.getAttribute('data-variant'), 10), quantity: qty }];
    form.querySelectorAll('[data-addon]:checked').forEach(function (box) {
      items.push({ id: parseInt(box.value, 10), quantity: 1 });
    });
    form.querySelectorAll('[data-addon-qty]').forEach(function (input) {
      var n = parseInt(input.value, 10) || 0;
      if (n > 0) items.push({ id: parseInt(input.getAttribute('data-addon-qty'), 10), quantity: n });
    });
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('[data-mdt-msg]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
      if (msg) msg.textContent = err.message + ' — please call us and we will place the order for you.';
    });
  });

  // Keep the add-to-cart total in step with ticked add-ons and add-on quantities.
  function updateTotal(e) {
    if (!e.target.matches || !e.target.matches('[data-addon], [data-addon-qty], [name="quantity"]')) return;
    var form = e.target.closest('[data-mdt-buy]');
    if (!form) return;
    var cents = (parseInt(form.getAttribute('data-price'), 10) || 0) * (parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10) || 1);
    form.querySelectorAll('[data-addon]:checked').forEach(function (b) { cents += parseInt(b.getAttribute('data-price'), 10) || 0; });
    form.querySelectorAll('[data-addon-qty]').forEach(function (q) {
      cents += (parseInt(q.getAttribute('data-price'), 10) || 0) * Math.max(0, parseInt(q.value, 10) || 0);
    });
    var label = form.querySelector('[data-mdt-total]');
    if (label) label.textContent = '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  document.addEventListener('change', updateTotal);
  document.addEventListener('input', updateTotal);
  // Starting quantities count from the first paint
  document.querySelectorAll('[data-mdt-buy] [data-addon-qty]').forEach(function (q) { if (parseInt(q.value, 10) > 0) updateTotal({ target: q }); });
})();
